import React, { ChangeEvent, useContext, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../redux/store';
import confirmDriverOnSite from '../../services/geolocation';
import { LoadingAnimationContext } from '../../contexts/LoadingAnimationContext';
import { updatePrecheck, getDriverActivePrecheck } from '../../services/APIs';
import ReportDetailText from './ReportDetailText';
import { PrecheckContext } from '../../contexts/PrecheckContext';
import { FormattedMessage } from 'react-intl';
import { CustomModalContext } from '../../contexts/CustomModalContext';
import dayjs from 'dayjs';
import { updateDriver } from '../../services/APIs';
import { useNavigate } from 'react-router-dom';

interface ActivePrecheck {
    _id: string;
    submittedDotNumber: string;
    submittedName: string;
    yardSpot: string;
    dockDoor: string;
    submittedTrailerNumber: string;
    submittedTrailerLength: string;
    submittedPhoneNumber: string;
    submittedReferenceId: string;
    submittedLanguage: 'en' | 'es' | 'ru';
    manhCustomerName: string;
    carrierName: string;
    carrierSCAC: string;
    manhAddress: string;
    pickupAppointment: Date;
    orderType: string;
}

const Report = () => {
    const { setShowLoading } = useContext(LoadingAnimationContext);
    const Navigate = useNavigate();
    const [isEditing, setisEditing] = useState(false);
    const checkinData = useSelector((state: RootState) => state.driverInfo);
    const [driverOnsite, setDriverOnsite] = useState<boolean>(!checkinData.isOffsite);
    const { precheckInfo ,setPrecheckInfo} = useContext(PrecheckContext);
    const { showModal } = useContext(CustomModalContext);
    const [activePrecheck, setActivePrecheck] = useState<ActivePrecheck | null>(null);
    const [activePrecheckCopy, setActivePrecheckCopy] = useState<ActivePrecheck | null>(null);
    
    const getPrecheckData = async () => {
        const precheckResponse = await getDriverActivePrecheck(precheckInfo.submittedPhoneNumber);
        if (precheckResponse && precheckResponse.data.precheck) {
            setActivePrecheck(precheckResponse.data.precheck);
            setActivePrecheckCopy(precheckResponse.data.precheck);
        }else {
            const orgCode = sessionStorage.getItem('orgCode');
            Navigate(`/?org=${orgCode}`);
        }
    };

    const handleDiscard = (name: keyof ActivePrecheck) => {
        try {
            if (activePrecheckCopy) {
                setActivePrecheck((prevState) => {
                    if (!prevState) return prevState;
                    return {
                        ...prevState,
                        [name]: activePrecheckCopy[name],
                    };
                });
            }
            setisEditing(false);
        } catch (error) {
            console.log(error);
        }
    };

    const onConfirmClick = async () => {
        const isDriverOnsite = await confirmDriverOnSite(precheckInfo.orgCode);
        if (isDriverOnsite) {
            if (activePrecheck){
                if (activePrecheck)
                    updatePrecheck(
                        activePrecheck._id,
                        { isOffsite: false },
                        activePrecheck.submittedLanguage
                    );
                setPrecheckInfo({ ...precheckInfo, isOffsite: false });
            }
            showModal({
                title: (
                    <FormattedMessage
                        id="reportSuccessGeolocationHeader"
                        defaultMessage="Request Submitted!"
                    />
                ),
                subtitle: (
                    <FormattedMessage
                        id="reportSuccessGeolocationText"
                        defaultMessage="We look forward to your arrival"
                    />
                ),
                buttonOneText: <FormattedMessage id="ok" defaultMessage="Okay" />
            });
        } else {
            showModal({
                title: (
                    <FormattedMessage
                        id="reportConfirmArrivalButton"
                        defaultMessage="Confirm Arrival"
                    />
                ),
                subtitle: (
                    <FormattedMessage
                        id="reportFailedGeolocationText"
                        defaultMessage='Please ensure that you are at the correct Niagara facility before clicking "Confirm Arrival".'
                    />
                ),
                buttonOneText: <FormattedMessage id="ok" defaultMessage="Okay" />
            });
        }
        setDriverOnsite(isDriverOnsite);
        setShowLoading(false);
    };

    const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
        const { name, value } = event.target;
        setActivePrecheck((prevState) => {
            if (!prevState) { return prevState; }
            return {
                ...prevState,
                [name]: value,
            };
        });
    };

    const handleConfirm = async () => {
        if (activePrecheck) {
            await updateDriver(activePrecheck._id, activePrecheck.submittedName);
        }
    };

    useEffect(() => {
        getPrecheckData();
    }, [isEditing]);

    return (
        <>
            <div className="body-container">
                <section className="appointment-wrapper">
                    <div className="checkout-process-tabber">
                        <div className="checkout-process-wrapper">
                            <div className="checkout-process-container container-890 checkin-appointment-container">
                                <h3 className="form-title mb-4 text-center">
                                    {' '}
                                    <FormattedMessage
                                        id="reportTitle"
                                        defaultMessage="Precheck Summary"
                                    />
                                </h3>
                                <div className="confirmation-detail">
                                    <div className="d-flex appointment-wrapper-box">
                                        <div className="confirmation-trailer-detail">
                                            {activePrecheck && !isEditing ? (
                                                <ul>
                                                    {activePrecheck.submittedName && (
                                                        <ReportDetailText
                                                            title={
                                                                <FormattedMessage
                                                                    id="reportLabelName"
                                                                    defaultMessage="Name"
                                                                />
                                                            }
                                                            name="submittedName"
                                                            handleConfirm={handleConfirm}
                                                            value={activePrecheck.submittedName}
                                                            onChange={handleChange}
                                                            isEditable={true}
                                                            isEditing={isEditing}
                                                            onDiscard={handleDiscard}
                                                            updateDriver={updateDriver}
                                                            id={activePrecheck._id}
                                                            valueName="submittedName"
                                                        />
                                                    )}
                                                    {activePrecheck.submittedDotNumber && (
                                                        <ReportDetailText
                                                            title={
                                                                <FormattedMessage
                                                                    id="reportLabelDotNumber"
                                                                    defaultMessage="USDOTNumber"
                                                                />
                                                            }
                                                            name='submittedDotNumber'
                                                            value={activePrecheck.submittedDotNumber}
                                                            isEditable={false}
                                                            onChange={handleChange}
                                                            isEditing={isEditing}
                                                            onDiscard={handleDiscard}
                                                            updateDriver={updateDriver}
                                                            id={activePrecheck._id}
                                                            valueName="submittedDotNumber"
                                                        />
                                                    )}
                                                    {activePrecheck.dockDoor && (
                                                        <ReportDetailText
                                                            title={
                                                                <FormattedMessage
                                                                    id="reportLabelDockDoor"
                                                                    defaultMessage="Dock Door"
                                                                />
                                                            }
                                                            name="dockDoor"
                                                            value={activePrecheck.dockDoor}
                                                            isEditable={false}
                                                        />
                                                    )}
                                                    {activePrecheck.orderType && (
                                                        <ReportDetailText
                                                            title={
                                                                <FormattedMessage
                                                                    id="reportLabelVistType"
                                                                    defaultMessage="Visit Type"
                                                                />
                                                            }
                                                            name="orderType"
                                                            value={activePrecheck.orderType}
                                                            isEditable={false}
                                                        />
                                                    )}
                                                    {activePrecheck.yardSpot && (
                                                        <ReportDetailText
                                                            title={
                                                                <FormattedMessage
                                                                    id="reportLabelYardSpot"
                                                                    defaultMessage="Yard Spot"
                                                                />
                                                            }
                                                            name="yardSpot"
                                                            value={activePrecheck.yardSpot}
                                                            isEditable={false}
                                                        />
                                                    )}
                                                    {activePrecheck.submittedPhoneNumber && (
                                                        <ReportDetailText
                                                            title={
                                                                <FormattedMessage
                                                                    id="reportLabelPhoneNumber"
                                                                    defaultMessage="Phone Number"
                                                                />
                                                            }
                                                            name="submittedPhoneNumber"
                                                            value={activePrecheck.submittedPhoneNumber}
                                                            isEditable={false}
                                                        />
                                                    )}
                                                    {activePrecheck.submittedReferenceId && (
                                                        <ReportDetailText
                                                            title={
                                                                <FormattedMessage
                                                                    id="reportLabelPickupNumber"
                                                                    defaultMessage="Pickup Number"
                                                                />
                                                            }
                                                            name="submittedReferenceId"
                                                            id={activePrecheck._id}
                                                            handleConfirm={handleConfirm}
                                                            value={activePrecheck.submittedReferenceId}
                                                            isEditable={true}
                                                            onChange={handleChange}
                                                            isEditing={isEditing}
                                                            onDiscard={handleDiscard}
                                                            updateDriver={updateDriver}
                                                            valueName="Pickup Number"
                                                        />
                                                    )}
                                                    {activePrecheck.submittedTrailerNumber && (
                                                        <ReportDetailText
                                                            title={
                                                                <FormattedMessage
                                                                    id="reportLabelTrailerNumber"
                                                                    defaultMessage="Trailer Number"
                                                                />
                                                            }
                                                            name="submittedTrailerNumber"
                                                            id={activePrecheck._id}
                                                            handleConfirm={handleConfirm}
                                                            value={activePrecheck.submittedTrailerNumber}
                                                            isEditable={true}
                                                            isEditing={isEditing}
                                                            onChange={handleChange}
                                                            onDiscard={handleDiscard}
                                                            updateDriver={updateDriver}
                                                            valueName="Trailer Number"
                                                        />
                                                    )}
                                                    {activePrecheck.submittedTrailerLength && (
                                                        <ReportDetailText
                                                            title={
                                                                <FormattedMessage
                                                                    id="reportLabelTrailerLength"
                                                                    defaultMessage="Trailer Length"
                                                                />
                                                            }
                                                            name="submittedTrailerLength"
                                                            handleConfirm={handleConfirm}
                                                            value={activePrecheck.submittedTrailerLength}
                                                            isEditable={true}
                                                            onChange={handleChange}
                                                            isEditing={isEditing}
                                                            onDiscard={handleDiscard}
                                                            updateDriver={updateDriver}
                                                            id={activePrecheck._id}
                                                            valueName="Trailer Length"
                                                        />
                                                    )}
                                                    {activePrecheck.manhCustomerName && (
                                                        <ReportDetailText
                                                            title={
                                                                <FormattedMessage
                                                                    id="reportLabelManhCustomerName"
                                                                    defaultMessage="Customer Name"
                                                                />
                                                            }
                                                            name="customerName"
                                                            value={activePrecheck.manhCustomerName}
                                                            isEditable={false}
                                                        />
                                                    )}
                                                    {activePrecheck.manhAddress && (
                                                        <ReportDetailText
                                                            title={
                                                                <FormattedMessage
                                                                    id="reportLabelManhAddress"
                                                                    defaultMessage="Destination"
                                                                />
                                                            }
                                                            name="address"
                                                            value={activePrecheck.manhAddress}
                                                            isEditable={false}
                                                        />
                                                    )}
                                                    {activePrecheck.pickupAppointment && (
                                                        <ReportDetailText
                                                            title={
                                                                <FormattedMessage
                                                                    id="reportLabelManhPickupAppointment"
                                                                    defaultMessage="Pickup Appointment Time"
                                                                />
                                                            }
                                                            name="pickupAppointment"
                                                            value={dayjs(
                                                                activePrecheck.pickupAppointment
                                                            ).format('MM/DD/YYYY hh:mm A')}
                                                            isEditable={false}
                                                        />
                                                    )}
                                                </ul>
                                            ) : null}
                                        </div>
                                    </div>
                                    <div className="w-100 d-flex justify-content-center">
                                        {driverOnsite ? (
                                            <button className="md-button my-4">
                                                <a
                                                    href={`sms://${process.env.REACT_APP_SMS_NUMBER}`}>
                                                    <FormattedMessage
                                                        id="reportContactButton"
                                                        defaultMessage="Contact Niagara Team"
                                                    />
                                                </a>
                                            </button>
                                        ) : (
                                            <div>
                                                {!isEditing ? <button
                                                    onClick={() => {
                                                        setShowLoading(true);
                                                        onConfirmClick();
                                                    }}
                                                    className="md-button my-4">
                                                    <FormattedMessage
                                                        id="reportConfirmArrivalButton"
                                                        defaultMessage="Confirm Arrival"
                                                    />
                                                </button> : null}
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </>
    );
};

export default Report;
